import { render, staticRenderFns } from "./centerRight2.vue?vue&type=template&id=7b451dbc&scoped=true&"
import script from "./centerRight2.vue?vue&type=script&lang=js&"
export * from "./centerRight2.vue?vue&type=script&lang=js&"
import style0 from "./centerRight2.vue?vue&type=style&index=0&id=7b451dbc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b451dbc",
  null
  
)

export default component.exports